<h1 class="center">Paramètres linge d'hébergement</h1>

<nav>
	<a class="tabs-orders" [ngClass]="isSelected ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="reloadData('commandes')">Clients commande</a>
	<a class="tabs-orders" [ngClass]="!isSelected ? 'tabs-orders-selected' : ''" routerLinkActive="active-link"
		(click)="reloadData('lots')">Clients lot</a>
</nav>

<div class="flex justify-center">
	<div class="clamp-commande">
		<div>
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event.target.value)" placeholder="Recherche"
					[(ngModel)]="filterValue">
				<mat-icon matSuffix>search</mat-icon>
			</mat-form-field>
		</div>
		<table mat-table class="commande-param-list" [dataSource]="dataSource">
			<ng-container matColumnDef="actions">
				<th mat-header-cell *matHeaderCellDef></th>
				<td class="list-actions-1" mat-cell *matCellDef="let row">
					<mat-icon (click)="selectClient(row)" class="icon-click">create</mat-icon>
				</td>
			</ng-container>
			<ng-container matColumnDef="raison_sociale">
				<th mat-header-cell *matHeaderCellDef>Code Client / Code Service - Raison Sociale</th>
				<td mat-cell *matCellDef="let element">{{ element.code_client }}/{{ element.code_service }} - {{
					element.raison_sociale }}</td>
			</ng-container>
			<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
			<tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectClient(row)" class="tr-click">
			</tr>
		</table>
		<div [hidden]="dataSource.data.length == 0">
			<mat-paginator [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
		</div>
	</div>
</div>
<router-outlet></router-outlet>